// @flow

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Layout from './layout';
import { openHamburgerMenu } from '../../services/ui';

export type Props = {
  children: any,
  user: User,
  changeProfile: (ProfileId: string) => void,
  authenticating: boolean,
  showModalBlur: boolean,
};

const mapState = ({ authentication, ui, sam }) => ({
  user: authentication.user,
  authenticating: authentication.authenticating,
  showModalBlur: ui.showModalBlur,
  showNavBar: ui.showNavBar,
  sysdownmessage: sam.sysdownmessage,
});

const mapDispatch = {
  openHamburgerMenu,
};

export default withRouter(
  connect(
    mapState,
    mapDispatch,
  )(Layout),
);
